/**
 * Handles opening modals based on URL parameters
 */
document.addEventListener('DOMContentLoaded', () => {
  const params = new URLSearchParams(window.location.search)
  const modalParam = params.get('modal')

  if (modalParam === 'account') {
    openLoginDrawer()
  }
})

const openLoginDrawer = () => {
  const accountTrigger = document.querySelector('[data-modal-parent="account"][data-modal-role="open"]')
  if (accountTrigger) {
    accountTrigger.click()
  }
}

window.openLoginDrawer = openLoginDrawer
